<template>
  <div class="container">
    <van-nav-bar left-text="返回" left-arrow @click-left="onClickLeft" />
    <div v-if="userid === -1 || data === null">
      <LoadingPage />
    </div>
    <div v-if="userid !== -1 && data !== null" style="padding-bottom: 80px">
      <p></p>
      <p></p>
      <van-cell-group>
        <van-cell title="课程原价" :value="'￥' + data.price_detail.original" />
        <van-cell title="应缴费用" :value="'￥' + data.price_detail.payable" />
        <van-cell
          title="本次课程已缴费用"
          :value="'￥' + data.price_detail.paid"
        />
        <van-cell title="剩余应缴" :value="'￥' + data.price_detail.residue" />
        <van-cell
          v-if="!data.is_earnest_done"
          style="color: red"
          title="注意，由于您尚未完整支付课程的定金，有些优惠可能会失效，最终应缴费用可能会产生变化。"
        />
      </van-cell-group>
      <h4>应缴费用的计算详情：</h4>
      <van-cell-group
        v-for="(course, course_key) in data.price_detail.details"
        :key="course_key"
      >
        <van-cell :title="course.name" style="text-align: left;font-weight: bold"/>
        <van-cell title="原价" :value="'￥' + course.original" />
        <van-cell
          v-if="course.adjust_earnest !== 0"
          title="调整已付定金"
          :value="'￥' + course.adjust_earnest"
        />
        <van-cell
          v-if="course.adjust !== 0"
          title="调整价格"
          :value="'￥' + course.adjust"
        />
        <van-cell
          v-if="course.adjust2 !== 0"
          title="调整抵扣"
          :value="'￥' + course.adjust2"
        />
        <van-cell
          v-for="(deduction, deduction_key) in course.deductions"
          :key="deduction_key"
        >
          {{ deduction }}
        </van-cell>
        <van-cell
          v-for="(coupon, coupon_key) in course.coupons"
          :key="coupon_key"
        >
          <div v-if="coupon_key > 1" style="color: #c5c5c5">{{ coupon }}</div>
          <div v-else>{{ coupon }}</div>
        </van-cell>
        <p></p>
        <p></p>
      </van-cell-group>
      <p></p>
      <p></p>
      <van-cell-group>
        <van-cell
          v-if="data.price_detail.union !== 0"
          title="课程联报优惠"
          :value="'￥-' + data.price_detail.union"
        ></van-cell>
        <van-cell
          v-if="data.price_detail.tax !== 0"
          title="开票手续费"
          :value="'￥' + data.price_detail.tax"
        ></van-cell>
      </van-cell-group>
    </div>
    <MainTabBar></MainTabBar>
  </div>
</template>

<script>
// import LoadingPage from "../../components/LoadingPage";
import MainTabBar from "../../components/MainTabBar";
import LoadingPage from "../../components/LoadingPage";
import { CellGroup, Cell, NavBar } from "vant";
import { getCourseInfoPriceDetail } from "../../services/user";
import { mapActions, mapState } from "vuex";
import { warningNotify } from "../../utils/notify";

export default {
  name: "price_details",
  props: ["id"],
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [NavBar.name]: NavBar,
    //"van-divider": Divider,
    LoadingPage,
    MainTabBar
  },
  data() {
    return {
      data: null,
      originalPrice: 10000,
      studentDiscount: 500,
      oldStudentDiscount: 500,
      groupDiscount: 500,
      onlineCourseDiscount: 500
    };
  },
  computed: {
    ...mapState({
      token: state => state.users.token,
      userid: state => state.users.userid
    }),
    totalPrice() {
      return (
        this.originalPrice -
        this.studentDiscount -
        this.oldStudentDiscount -
        this.groupDiscount -
        this.onlineCourseDiscount
      );
    }
  },
  methods: {
    ...mapActions({ tokenChecker: "users_tokenChecker" }),
    onClickLeft() {
      // 返回上一页
      this.$router.go(-1);
    },
    getPriceDetail() {
      if (this.token === "") {
        return;
      }
      let infoId = this.$route.params.id;
      getCourseInfoPriceDetail(this.token, infoId).then(result => {
        if (!result.status) {
          warningNotify("获取数据失败！");
          return;
        }
        this.data = result.data;
        this.isDataGot = true;
      });
    }
  },
  beforeMount() {
    // 应该在每个登录才能操作的视图加上下面这句
    this.tokenChecker();
    this.$store.state.system.tabBarActive = "user";
    if (this.data === null) {
      this.getPriceDetail();
    }
  },
  updated() {
    if (this.data === null) {
      this.getPriceDetail();
    }
  }
};
</script>

<style scoped>
.container {
  margin: 10px;
}
.button-container {
  display: flex;
  justify-content: center;
}
</style>
